import { useEffect, useState, useContext } from "react";

import IconButton from "@mui/material/IconButton";
import { Box, Grid, Typography, Button } from "@mui/material";
import FilterAltSharpIcon from "@mui/icons-material/FilterAltSharp";
import { GetComponentTypes } from "../model/ComponentTypes";
import { Menu, MenuItem } from "@mui/material";
import { InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import { WidgetContext } from "./CreateWidgetWithComponent";
import Icon from "@vds/icons";

export default function WidgetButton({ icon }) {
  const widgetData = useContext(WidgetContext);

  const [anchorEl, setAnchorEl] = useState(null);
  let setCompInfo = widgetData.setCompInfo;
  let compData = widgetData.compData;

  //For Filter Menu
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseData = (data) => {
    setAnchorEl(null);
    switch (data) {
      case "Pending":
        setCompInfo(compData[1] ? [compData[1]] : compData);
        break;
      case "Active":
        setCompInfo(compData[0] ? [compData[0]] : compData);
        break;

      default:
        setCompInfo(compData);
    }
  };

  return (
    <>
      {widgetData.title === "Sensors" ? (
        <>
          <Button
            id="demo-positioned-button"
            aria-controls={open ? "demo-positioned-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            {icon}
          </Button>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem
              onClick={() => {
                handleClose();
              }}
            >
              Modal?
            </MenuItem>
          </Menu>
        </>
      ) : (
        ""
      )}

      {widgetData.title === "Gateway Health" ? (
        <>
          <Button
            id="demo-positioned-button"
            aria-controls={open ? "demo-positioned-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <Icon name="filter" size="large" />
          </Button>
          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleCloseData}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem
              onClick={() => {
                handleCloseData("Pending");
              }}
            >
              Pending Activation
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseData("Active");
              }}
            >
              Active
            </MenuItem>
            <MenuItem onClick={handleCloseData}>All</MenuItem>
          </Menu>
        </>
      ) : (
        ""
      )}
    </>
  );
}
